// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { assignDriverToTrip } from '../../services/TripsService';
import { AssignDriverToTripRequest, TripDetails } from '../../types/Trips';

type Result = UseMutationResult<TripDetails, Error, AssignDriverToTripRequest>;

function useAssignDriverToTrip(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(assignDriverToTrip, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['trip'] });
      queryClient.invalidateQueries({ queryKey: ['trips'] });
      queryClient.invalidateQueries({ queryKey: ['driver'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAssignDriverToTrip;
